import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    salaryRequest: Yup.number()
        .nullable(true)
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val <= 999999999;
            return true;
        }),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formSalaryRequest">
                <Form.Label>Gehaltswunsch jährlich</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Jährlichen Gehaltswunsch eingeben"
                    type="text"
                    name="salaryRequest"
                    value={values.salaryRequest || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequest && !errors.salaryRequest}
                    isInvalid={touched.salaryRequest && errors.salaryRequest}
                    maxLength={9}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequest}
                </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formEntranceDate">
                <Form.Label>Frühestmöglicher Eintritt</Form.Label>
                <CustomFormControl
                    colors={colors}
                    type="date"
                    name="entranceDate"
                    value={values.entranceDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.entranceDate && !errors.entranceDate}
                    isInvalid={touched.entranceDate && errors.entranceDate}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.entranceDate}
                </Form.Control.Feedback>
            </Form.Group>
      </>
    );
};